const CompanyList = () => import('Views/company/company-list');
const CompanyAddEdit = () => import('Views/company/company-addEdit');
const CompanyDetail = () => import('Views/company/company-detail');

export default[
  { path: '/company-list', component: CompanyList },
  { path: '/company-add', component: CompanyAddEdit },
  { path: '/company-edit/:id', component: CompanyAddEdit },
  { path: '/company-detail/:id', component: CompanyDetail },
];



// WEBPACK FOOTER //
// ./src/router/company.js